import { useState } from 'react';
import { NavLink } from 'react-router';
import type { Folder } from '@/domain/tags';
import { Icon } from '@/ui/Icon';

export function folderUrl(key: string): string {
  return `/folder/${encodeURIComponent(key)}`;
}

/** Collapsible tag folder tree for the navigation drawer. */
export function FolderTree({ folders, onNavigate }: { folders: Folder[]; onNavigate?: () => void }) {
  return (
    <ul className="folder-tree" role="tree">
      {folders.map((f) => (
        <FolderItem key={f.key} folder={f} onNavigate={onNavigate} />
      ))}
    </ul>
  );
}

function FolderItem({ folder, onNavigate }: { folder: Folder; onNavigate?: (() => void) | undefined }) {
  const [open, setOpen] = useState(false);
  const hasChildren = folder.children.length > 0;
  return (
    <li role="treeitem" aria-expanded={hasChildren ? open : undefined} aria-selected={false}>
      <div className="nav-item-row" style={{ paddingInlineStart: folder.depth * 16 }}>
        <NavLink to={folderUrl(folder.key)} className="nav-item" onClick={onNavigate}>
          <Icon name={open ? 'folder_open' : 'folder'} />
          <span className="nav-item__label">{folder.name}</span>
          <span className="nav-item__badge">{folder.count}</span>
        </NavLink>
        {hasChildren && (
          <button
            type="button"
            className={`nav-item__toggle${open ? ' is-open' : ''}`}
            aria-label={open ? `${folder.name} zuklappen` : `${folder.name} aufklappen`}
            onClick={() => setOpen((o) => !o)}
          >
            <Icon name="keyboard_arrow_down" size={20} />
          </button>
        )}
      </div>
      {hasChildren && open && (
        <ul role="group">
          {folder.children.map((c) => (
            <FolderItem key={c.key} folder={c} onNavigate={onNavigate} />
          ))}
        </ul>
      )}
    </li>
  );
}
